import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { NotificationService } from '../../services/notification.service';
import { OrderService } from '../../services/order.service';
import { RecordLockService } from '../../services/recordlock.service';
import { UtilService } from '../../services/util.service';
import {
    RecordType,
    TagType
} from '../../models/models';

@Component({
    selector: 'tag-type-form',
    templateUrl: './tag-type-form.component.html',
    standalone: false
})
export class TagTypeForm implements OnChanges {
    @Input() tableID: number = 0;
    @Output() onRefresh = new EventEmitter<any>();

    public tableItem: TagType = {} as TagType;
    public recordTypeList: RecordType[] = [];

    constructor(private notificationService: NotificationService, private orderService: OrderService,
        private recordLockService: RecordLockService, private utilService: UtilService) {
    }

    ngOnChanges() {
        this.getTableItem();
        this.getRecordTypes();
        //console.log("ngOnChanges", this.tableID, this.carrierID);
    }

    private getRecordTypes() {
        this.utilService.isLoading = true;
        this.recordLockService.getRecordTypes().subscribe(result => {
            this.utilService.isLoading = false;
            this.recordTypeList = result.resultCollection;
            this.recordTypeList = this.recordTypeList.filter(t => t.recordTypeName == "QuoteOrder"
                || t.recordTypeName == "Customer"
                || t.recordTypeName == "QuoteOrderLine");
        });
    }

    private getTableItem() {
        if (this.tableID > 0) {
            this.orderService.getTagTypeByID(this.tableID).subscribe(result => {
                if (result.resultCollection.length > 0) {
                    this.tableItem = result.resultCollection[0];
                }
            });
        }
        else {
            //var employeeID = parseInt(localStorage.getItem('EmployeeId')!);
            this.tableItem = {
                tagTypeID: 0,
                tagTypePrefix: "",
                tagTypeName: "",
                tagTypeDescription: "",
                isTrackingVisible: false,
                isActive: true,
                colorClassName: "",
                recordTypeID: 0,
                createdByEmployeeID: 0,
                createdDate: new Date(),
                lastModifiedByEmployeeID: 0,
                lastModifiedDate: new Date()
            };
        }
    }

    public save() {
        this.utilService.isLoading = true;
        console.log("save", this.tableItem);
        this.orderService.saveTagType(this.tableItem).subscribe(result => {
            this.utilService.isLoading = false;
            if (result.resultCollection.length > 0) {
                this.onRefresh.emit();
            } else {
                this.notificationService.showError("Failed to save record.", "ERROR: Failed to Save");
                this.onRefresh.emit();
            }
        });

        this.tableItem = {} as TagType;
    }

    public cancel() {
        this.onRefresh.emit();
    }
}